import { ThemeOptions } from '@material-ui/core';

import {
  publicSans,
  publicSansSemiBold,
  publicSansBold,
} from './font-public-sans';

export const fontFamily = [
  '"Public Sans Web"',
  'sans-serif',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  '"Helvetica Neue"',
  'Arial',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(', ');

const background = '#F2F2F2';

export const theme: ThemeOptions = {
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [publicSans, publicSansSemiBold, publicSansBold],
        '*': {
          '-webkit-font-smoothing': 'antialiased !important',
          '-webkit-tap-highlight-color': 'transparent',
        },
        html: {
          WebkitFontSmoothing: 'antialiased !important',
        },
        body: {
          backgroundColor: `${background} !important`,
          overflowX: 'hidden',
          overflowY: 'auto',
          margin: 0,
          fontFamily,
          '-webkit-font-smoothing': 'antialiased',
          '-moz-osx-font-smoothing': 'grayscale',
        },
        code: {
          fontFamily:
            "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
        },
        '.switch-wrapper': {
          position: 'relative',
        },
        '.switch-wrapper > div': {
          position: 'absolute',
        },
      },
    },
  },
  palette: {
    background: {
      default: background,
    },
    primary: {
      dark: '#7229E6',
      main: '#863bff',
      light: '#C099FF',
      contrastText: '#EEE3FF',
    },
    secondary: {
      dark: '#C95100',
      main: '#FF6600',
      light: '#FFB380',
      contrastText: '#FFE9DB',
    },
    error: {
      dark: '#D40728',
      main: '#FF4D6A',
      light: '#FFBDC8',
      contrastText: '#FFF8E3',
    },
    warning: {
      dark: '#916B00',
      main: '#FFC938',
      light: '#FFE7A7',
      contrastText: '#DEFAF3',
    },
    info: {
      dark: '#0075B0',
      main: '#49B9F2',
      light: '#B4E3FB',
      contrastText: '#E3F6FF',
    },
    success: {
      dark: '#008262',
      main: '#28D2A7',
      light: '#A6EDDB',
      contrastText: '#DEFAF3',
    },
    grey: {
      '50': '#FAFAFB',
      '100': '#F0F1F2',
      '200': '#E5E7EB',
      '300': '#CFD2D9',
      '400': '#ABB0BA',
      '500': '#727780',
      '600': '#4A4F58',
      '700': '#262930',
    },
    text: {
      primary: '#262930',
      secondary: '#4A4F58',
      hint: '#727780',
      disabled: '#ABB0BA',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    fontFamily,
    h1: {
      fontSize: '32px',
      lineHeight: '40px',
      fontWeight: 'bold',
      WebkitFontSmoothing: 'antialiased !important',
    },
    h2: {
      fontSize: '28px',
      lineHeight: '32px',
      fontWeight: 'bold',
      WebkitFontSmoothing: 'antialiased !important',
    },
    h3: {
      fontSize: '24px',
      lineHeight: '32px',
      fontWeight: 'bold',
      WebkitFontSmoothing: 'antialiased !important',
    },
    h4: {
      fontSize: '20px',
      lineHeight: '24px',
      fontWeight: 600,
      WebkitFontSmoothing: 'antialiased !important',
    },
    h5: {
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 600,
      WebkitFontSmoothing: 'antialiased !important',
    },
    h6: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 600,
      WebkitFontSmoothing: 'antialiased !important',
    },
  },
};
